import { axiosGet, axiosPost } from "../../RestApis/restApiUseAxios";
import axiosInstance from "../axios/axios";

const quoteList = async (body) => {
  try {
    const response = await axiosInstance.post("/quotes/getAllQuotes", body); // replace with your endpoint
    //console.log("quoteList--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching quoteList:", error);
  }
};
const getCatogeryById = async (categoryId) => {
  try {
    //console.log("getCatogeryById===>", categoryId);
    const response = await axiosInstance.get(
      `/Category/getCategoryDetailsByCategoryId/${categoryId}`
    ); // replace with your endpoint
    //console.log("getCatogeryById--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getCatogeryById:", error);
  }
};
const getAllAgent = async () => {
  try {
    const response = await axiosInstance.get(`/Agent/getAllAgents`); // replace with your endpoint
    //console.log("getAllAgent--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getAllAgent:", error);
  }
};
const getQuoteById = async (body) => {
  console.log("getQuoteById===>", body);
  try {
    const response = await axiosInstance.post(`/quotes/getAllQuotes`, body); // replace with your endpoint
    //console.log("getQuoteById--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getQuoteById:", error);
  }
};
const updateQuote = async (userId, companyId, body) => {
  //console.log("updateQuote===>", userId, companyId, body);
  try {
    const response = await axiosInstance.post(
      `/quotes/updateQuote/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("updateQuote--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching updateQuote:", error);
  }
};
const addQuote = async (userId, companyId, body) => {
  //console.log("addQuote===>", userId, companyId, body);
  try {
    const response = await axiosInstance.post(
      `/quotes/addQuote/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("addQuote--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching addQuote:", error);
  }
};
const getAllQuoteEntities = async (quoteId) => {
  try {
    const response = await axiosInstance.get(
      `/quoteEntity/getAllQuoteEntities/${quoteId}`
    ); // replace with your endpoint
    //console.log("getAllQuoteEntities--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getAllQuoteEntities:", error);
  }
};
const getQuoteAnnualEntities = async (quoteId, ConsumptionId) => {
  try {
    const response = await axiosInstance.get(
      `/quoteEntity/getQuoteEntityConsumptionAndHeaderByEntityId/${quoteId}/${ConsumptionId}`
    ); // replace with your endpoint
    //console.log("getQuoteAnnualEntities--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getQuoteAnnualEntities:", error);
  }
};
const updateQuoteEntity = async (userId, companyId, body) => {
  try {
    //console.log("updateQuoteEntity===>", userId, companyId, body);
    const response = await axiosInstance.post(
      `/quoteEntity/updateQuoteEntity/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("updateQuoteEntity--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching updateQuoteEntity:", error);
  }
};
const addQuoteEntity = async (userId, companyId, body) => {
  try {
    //console.log("addQuoteEntity===>", userId, companyId, body);
    const response = await axiosInstance.post(
      `/quoteEntity/addQuoteEntity/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("addQuoteEntity--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching addQuoteEntity:", error);
  }
};
const getEntityConsumptionHeaderByQuoteId = async (leadId) => {
  console.log("getEntityConsumptionHeaderByQuoteId===>", leadId);
  try {
    const response = await axiosInstance.get(
      `/quoteEntity/getEntityConsumptionHeaderByQuoteId/${leadId}`
    ); // replace with your endpoint
    //console.log("getEntityConsumptionHeaderByQuoteId--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getEntityConsumptionHeaderByQuoteId:", error);
  }
};
const getAnnualEntityConsumptionByQuoteId = async (quoteId) => {
  //console.log("getAnnualEntityConsumptionByQuoteId===>", quoteId);
  try {
    const response = await axiosInstance.get(
      `/quoteEntity/getAnnualEntityConsumptionByQuoteId/${quoteId}`
    ); // replace with your endpoint
    //console.log("getAnnualEntityConsumptionByQuoteId--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getAnnualEntityConsumptionByQuoteId:", error);
  }
};
const addQuoteEntityAnnualConsumptionByQuoteId = async (
  userId,
  companyId,
  quoteId,
  body
) => {
  try {
    const response = await axiosInstance.post(
      `/QuoteEntity/addQuoteEntityAnnualConsumptionByQuoteId/${userId}/${companyId}/${quoteId}`,
      body
    ); // replace with your endpoint
    //console.log("addQuoteEntityAnnualConsumptionByQuoteId--->", response?.data);
    return response;
  } catch (error) {
    console.error(
      "Error fetching addQuoteEntityAnnualConsumptionByQuoteId:",
      error
    );
  }
};
const updateQuoteEntityAnnualConsumptionByQuoteId = async (
  userId,
  companyId,
  quoteId,
  body
) => {
  try {
    const response = await axiosInstance.post(
      `/QuoteEntity/updateQuoteEntityAnnualConsumptionByQuoteId/${userId}/${companyId}/${quoteId}`,
      body
    ); // replace with your endpoint
    // console.log(
    //   "updateQuoteEntityAnnualConsumptionByQuoteId--->",
    //   response?.data
    // );
    return response;
  } catch (error) {
    console.error(
      "Error fetching updateQuoteEntityAnnualConsumptionByQuoteId:",
      error
    );
  }
};
const addQuoteEntityConsumptionHeadersByQuoteId = async (
  quoteId,
  userId,
  companyId,
  body
) => {
  try {
    // console.log(
    //   "addQuoteEntityConsumptionHeadersByQuoteId===>",
    //   quoteId,
    //   userId,
    //   companyId,
    //   body
    // );
    const response = await axiosInstance.post(
      `QuoteEntity/addQuoteEntityConsumptionHeadersByQuoteId/${companyId}/${userId}/${quoteId}`,
      body
    ); // replace with your endpoint
    //console.log("addQuoteEntityConsumptionHeadersByQuoteId--->", response?.data);
    return response;
  } catch (error) {
    console.error(
      "Error fetching addQuoteEntityConsumptionHeadersByQuoteId:",
      error
    );
  }
};
const addQuoteEntityBulkUpload = async (userId, companyId, quoteId, body) => {
  try {
    const response = await axiosInstance.post(
      `/QuoteEntity/addQuoteEntityBulkUpload/${userId}/${companyId}/${quoteId}`,
      body
    ); // replace with your endpoint
    //console.log("addQuoteEntityBulkUpload--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching addQuoteEntityBulkUpload:", error);
  }
};
const deleteEntity = async (quoteId, entityInfoId) => {
  try {
    const response = await axiosInstance.get(
      `/quoteEntity/deleteQuoteEntity/${quoteId}/${entityInfoId}`
    );
    console.log("deleteEntity===>", response?.data?.payload);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};
const updateSelectedLoe = async (userId, companyId, quoteId, loeId) => {
  try {
    const response = await axiosInstance.post(
      `/QuoteLoeFile/updateSelectedLoe/${userId}/${companyId}/${quoteId}/${loeId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching updateSelectedLoe:", error);
  }
};
const currentSupplier = async (id) => {
  try {
    const response = await axiosInstance.get(`/Supplier/getAllSuppliers/${id}`); // replace with your endpoint
    //console.log("currentSupplier--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching currentSupplier:", error);
  }
};
const getCategoryDropdownById = async (categoryId) => {
  try {
    const response = await axiosInstance.get(
      `/Category/getCategoryDetailsByCategoryId/${categoryId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching getCategoryDropdownById:", error);
  }
};
const utilityCompany = async (body) => {
  try {
    const response = await axiosInstance.post(
      `/UtilityCompany/getAllUtilityCompany`,
      body
    ); // replace with your endpoint
    //console.log("utilityCompany--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching utilityCompany:", error);
  }
};
const getPositionDropdown = async () => {
  try {
    const response = await axiosInstance.get(`/Positions/getAllPositions`);
    //console.log("getPositionDropdown", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};
const addCustomerContact = async (userId, companyId, customerId, body) => {
  try {
    debugger;
    const response = await axiosInstance.post(
      `/Customer/addCustomerContact/${userId}/${companyId}/${customerId}`,
      body
    );
    //console.log("addCustomerContact--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};
const importQuoteBulkEntityData = async (body) => {
  try {
    const response = await axiosPost(`/quote/import-bulk-entity-data`, {
      CompanyId: body?.companyId,
      CustomerId: body?.customerId,
      BranchId: body?.branchId,
      UserId: body?.userId,
      QuoteBulkEntityList: body?.quoteBulkEntityList,
      QuoteId: body?.quoteId,
      MonthName1: body?.monthName1,
      MonthName2: body?.monthName2,
      MonthName3: body?.monthName3,
      MonthName4: body?.monthName4,
      MonthName5: body?.monthName5,
      MonthName6: body?.monthName6,
      MonthName7: body?.monthName7,
      MonthName8: body?.monthName8,
      MonthName9: body?.monthName9,
      MonthName10: body?.monthName10,
      MonthName11: body?.monthName11,
      MonthName12: body?.monthName12,
    });
    return response;
  } catch (error) {
    console.error("Error fetching importQuoteBulkEntityData:", error);
  }
};

const getQuoteBulkEntityList = async (quoteId, branchId, companyId) => {
  try {
    const response = await axiosGet(`/quote/bulk-entity-list`, {
      QuoteId: quoteId,
      BranchId: branchId,
      CompanyId: companyId,
    });
    return response;
  } catch (error) {
    console.error("Error fetching getQuoteBulkEntityList:", error);
  }
};

const validateBulkQuoteEntityInfo = async (body) => {
  try {
    const response = await axiosPost(`/quote/validate-bulk-quote-entity-info`, {
      QuoteBulkEntityValidationLst: body?.quoteBulkEntityValidationLst,
      QuoteId: body?.quoteId,
    });
    return response;
  } catch (error) {
    console.error("Error fetching validateBulkQuoteEntityInfo:", error);
  }
};

const processQuoteBulkEntity = async (body) => {
  try {
    const response = await axiosPost(`/quote/process-bulk-quote-entity-info`, {
      QuoteBulkEntityList: body?.quoteBulkEntityList,
      BranchId: body?.branchId,
      CompanyId: body?.companyId,
      QuoteId: body?.quoteId,
      IsAnnualConsumption: body?.isAnnualConsumption,
      ProductId: body?.productId,
    });
    return response;
  } catch (error) {
    console.error("Error fetching processQuoteBulkEntity:", error);
  }
};

const truncateQuoteEntityLog = async () => {
  try {
    const response = await axiosPost(`/quote/truncate-quote-entity-log`);
    return response;
  } catch (error) {
    console.error("Error fetching truncateQuoteEntityLog:", error);
  }
};

const addQuoteMultipleTermMonths = async (body) => {
  try {
    const response = await axiosPost(`/quote/add-quote-multiple_term_months`, {
      QuoteId: body?.quoteId,
      ContractTermId: body?.contractTermId,
    });
    return response;
  } catch (error) {
    console.error("Error fetching addQuoteMultipleTermMonths:", error);
  }
};

const updateQuoteMultipleTermMonths = async (body) => {
  try {
    const response = await axiosPost(
      `/quote/update-quote-multiple_term_months`,
      {
        QuoteId: body?.quoteId,
        ContractTermId: body?.contractTermId,
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching updateQuoteMultipleTermMonths:", error);
  }
};

const getBidDealers = async () => {
  try {
    debugger;
    const response = await axiosInstance.get("/User/getBidDealers");
    return response;
  } catch (error) {
    console.log("Error in fetching getBidDealers===>", error)
  }
}

export const QuoteService = {
  quoteList,
  getCatogeryById,
  getAllAgent,
  getQuoteById,
  updateQuote,
  getAllQuoteEntities,
  addQuote,
  updateQuoteEntity,
  getQuoteAnnualEntities,
  addQuoteEntity,
  getEntityConsumptionHeaderByQuoteId,
  addQuoteEntityAnnualConsumptionByQuoteId,
  updateQuoteEntityAnnualConsumptionByQuoteId,
  getAnnualEntityConsumptionByQuoteId,
  addQuoteEntityConsumptionHeadersByQuoteId,
  addQuoteEntityBulkUpload,
  deleteEntity,
  updateSelectedLoe,
  currentSupplier,
  getCategoryDropdownById,
  utilityCompany,
  getPositionDropdown,
  addCustomerContact,
  importQuoteBulkEntityData,
  getQuoteBulkEntityList,
  validateBulkQuoteEntityInfo,
  processQuoteBulkEntity,
  truncateQuoteEntityLog,
  addQuoteMultipleTermMonths,
  updateQuoteMultipleTermMonths,
  getBidDealers,
};
